import { call, put, delay } from "redux-saga/effects";
import { sampleApi, uploadAPI } from "@services/api";
import { uploadImageActions } from "../slices";

function* uploadImageWorker({ payload }) {
  //   yield delay(300);
  try {
    yield put(uploadImageActions.pending());
    const response = yield call(uploadAPI.uploadImage, payload);
    yield put(uploadImageActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(uploadImageActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { uploadImageWorker };
